<div class="search-profile-container">
  <app-search-profile-card class="card-size"
    [facId]="facItem.id"
    [card]="card"
    (editClick)="editCard(i)"
    (removeClick)="removeCard(i)"
    *ngFor="let card of facItem.search_profiles; let i = index"></app-search-profile-card>
  <div class="add-card card-size" (click)="createCard()">
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.9678 8.06823H15.9738V15.9737H8.06831V17.9677H15.9738V25.8732H17.9678V17.9677H25.8733V15.9737H17.9678V8.06823Z" fill="#ACACAC"/>
    </svg>      
  </div>
</div>
